/* Salo: switch a one-time cart line to the subscription plan, in place.
   Markup comes from snippets/salo-sub-nudge.liquid. One delegated handler,
   bound once, so it keeps working after the drawer re-renders its HTML. */
(function () {
  if (window.__saloSubNudge) return;
  window.__saloSubNudge = true;

  /* PREVIEW GATE: hidden for customers until approved. ?salopreview=1 turns it on for this browser tab. */
  var LIVE = true;
  try { if (/[?&]salopreview=1/.test(location.search)) sessionStorage.setItem('saloSubNudge', '1'); } catch (e) {}
  var on = LIVE; try { on = on || sessionStorage.getItem('saloSubNudge') === '1'; } catch (e) {}
  if (on) document.documentElement.classList.add('salo-subnudge-on');

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-salo-subnudge]');
    if (!btn) return;
    e.preventDefault();

    var box = btn.closest('.salo-subnudge');
    var line = parseInt(box.dataset.line, 10);
    var qty = parseInt(box.dataset.qty, 10) || 1;
    var plan = box.dataset.plan;

    btn.disabled = true;
    btn.textContent = 'Switching';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, selling_plan: plan })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart change ' + r.status); return r.json(); })
      .then(function () {
        var onCartPage = /^\/cart\/?$/.test(location.pathname);
        if (!onCartPage && typeof window.refreshCart === 'function' && document.getElementById('AjaxCartForm')) {
          window.refreshCart(true);
        } else {
          location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Switch';
      });
  });
})();
